// extracted by mini-css-extract-plugin
export default {"files-container":"Files_files-container__Q2c4B","btn-container":"Files_btn-container__lNnVq","file-btn":"Files_file-btn__wn0BW"};